import { restRequest as o, REST_VERBS as r, FETCH_MODE as u, RequestCredentialsValue as l } from "@ado/base-service";
import { UserAccountOperationResult as d } from "../types/index.js";
import { clearUserLicensesInCache as p } from "@ado/user-license-service";
const a = "/api/foundation/user-account-management/v2/", i = `${a}session`;
function T(t, n, e = {}) {
  const c = {
    data: {
      userCredentials: {
        username: t,
        password: n
      },
      auxiliaryParams: e
    }
  };
  return s(
    o(r.POST, i, c)
  );
}
function I(t, n) {
  const e = {
    data: {
      secureID: t
    },
    origin: "https://" + n,
    mode: u.CORS,
    credentials: l.Include
  };
  return s(
    o(r.POST, `${a}secure-session`, e)
  );
}
function R(t, n = null) {
  const e = {
    data: {
      email: t,
      returnProduct: n
    }
  };
  return s(
    o(
      r.POST,
      `${a}account/password-recovery`,
      e
    )
  );
}
function w(t, n, e = {}) {
  const c = {
    data: {
      userCredentials: {
        username: t,
        password: n
      },
      ...e
    }
  };
  return s(
    o(r.POST, `${a}account`, c)
  );
}
async function s(t) {
  const e = await t;
  return new d(e);
}
async function y() {
  try {
    const t = await s(
      o(r.DELETE, i, { data: {} })
    );
    return O(t), t;
  } catch (t) {
    throw h(), t;
  }
}
function m(t) {
  const n = t.map(f);
  return Promise.all(n);
}
function f(t) {
  const n = {
    data: {},
    origin: "https://" + t,
    mode: u.CORS,
    credentials: l.Include
  };
  return s(
    o(r.DELETE, i, n)
  );
}
function g() {
  document.location = "/";
}
function h() {
  alert("There was an error while trying to sign you out. Please try again. If the problem persists contact technical support.");
}
function O(t) {
  if (t.succeeded) {
    const n = t.result ? t.result.otherHosts : [];
    m(n), p(), g();
  } else
    alert(t.statusDescription);
}
export {
  w as createAccount,
  R as recoverPassword,
  T as signIn,
  I as signInSecure,
  y as signOut,
  m as signOutFromOtherHosts
};
//# sourceMappingURL=index.js.map
